<div class="flex gap-2 justify-end">
  <app-pan-button color="primary" icon="add" (click)="params.addCallback(params.data)" matTooltip="Add Location Shrink"></app-pan-button>
</div>
